export default __webpack_public_path__ + "static/media/lock-open.156112f8.svg";